import { connect } from 'react-redux'
import { get } from 'lodash'
import LandingHeader from './LandingHeader'

const stateToProps = ({ cms, scroll, auth }) => ({
  cms: get(cms, 'header[0].fields', {}),
  atTop: scroll.atTop,
  isLoggedIn: auth.token && auth.user && auth.user.id,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(LandingHeader)



// WEBPACK FOOTER //
// ./src/components/LandingHeader/LandingHeader.container.js